import urls from '../api_urls/commentKeywords'
import { _post, _upload } from '@/axios/request'
import $axios from '@/axios/config.js'
// 获取列表
export function getTableData (params) {
  return _post(urls.GET_LIST, params)
}

// 新增
export function save (params) {
  return _post(urls.SAVE, params)
}

// 获取详情
export function getDetail (params) {
  return _post(urls.GET_DETAIL, params)
}

// 更新
export function update (params) {
  return _post(urls.UPDATE, params)
}

// 切换状态
export function changeStatus (params) {
  return _post(urls.CHANGE_STATUS, params)
}

// 删除
export function del (params) {
  return _post(urls.DELETE, params)
}

// 导入
export function uploadFile (params) {
  return _upload(urls.UPLOAD, params)
}

// 下载
export function downloadFile (params) {
  return $axios({
    url: urls.DOWNLOAD,
    method: 'get',
    params,
    responseType: 'arraybuffer'
  })
}



// WEBPACK FOOTER //
// ./src/axios/api/commentKeywords.js